import { useMutation, useQuery } from '@tanstack/react-query'
import { toast } from '@telavita-core/react-design-kit'

import { 
  fetchNotificationPreferences, 
  updateNotificationPreferences,
  IPhoneNotificationData
} from 'services/me/preferences'

import { PHONE_NOTIFICATION_PREFERENCES } from 'settings/_reactQueryConstants'

const toastInstance = (type: 'success' | 'error', text: string) => toast({
  type,
  text,
  position: 'top-right',
  autoClose: 3000,
  closeOnClick: true,
})

export const useBannerNotificationService = (): IPhoneNotificationData => {  
  const { data, isError, refetch } = useQuery({
    queryKey: [PHONE_NOTIFICATION_PREFERENCES],
    queryFn: fetchNotificationPreferences,
    retry: false,
    refetchOnWindowFocus: true,
  })

  const { mutate: updatePhoneNotification, isLoading, isSuccess } = useMutation({
    mutationFn: updateNotificationPreferences,
    onSuccess: () => {
      refetch()
    }
  })

  if (isError) {
    toastInstance('error', 'Erro ao carregar as preferências de notificações')
  }

  return {
    data,
    isLoading,
    isSuccess,
    updatePhoneNotification
  }
}